function normalizeQuery(value) {
    return String(value || '')
        .trim()
        .toUpperCase()
        .replace(/\s+/g, ' ');
}

function scoreNameMatch(name, query) {
    if (!name || !query) {
        return 0;
    }

    if (name === query) {
        return 1000;
    }

    if (name.indexOf(query) === 0) {
        return 800;
    }

    if (name.indexOf(query) !== -1) {
        return 500;
    }

    var words = query.split(' ').filter(Boolean);
    var matched = 0;

    words.forEach(function (word) {
        if (word.length < 2) {
            return;
        }

        if (name.indexOf(word) !== -1) {
            matched += 1;
        }
    });

    if (!matched) {
        return 0;
    }

    if (matched === words.length) {
        return 300 + matched * 10;
    }

    return 100 + matched * 10;
}

function filterHeroesIndex(index, query, limit) {
    var normalizedQuery = normalizeQuery(query);

    if (!normalizedQuery) {
        return [];
    }

    var scored = index
        .map(function (item) {
            var name = normalizeQuery(item.name);

            return {
                score: scoreNameMatch(name, normalizedQuery),
                name: item.name,
                slug: item.slug,
            };
        })
        .filter(function (item) {
            return item.score > 0;
        })
        .sort(function (a, b) {
            if (b.score !== a.score) {
                return b.score - a.score;
            }

            return a.name.localeCompare(b.name, 'ru');
        });

    return scored.slice(0, limit).map(function (item) {
        return {
            name: item.name,
            slug: item.slug,
        };
    });
}

function parseHeroesIndex(menu) {
    var raw = menu.getAttribute('data-museum-heroes-index');

    if (!raw) {
        return null;
    }

    try {
        var parsed = JSON.parse(raw);

        return Array.isArray(parsed) ? parsed : null;
    } catch (error) {
        return null;
    }
}

function buildHeroUrl(template, slug) {
    return template.replace('__slug__', encodeURIComponent(slug));
}

function escapeHtml(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

export function initHeroesSearch() {
    var menu = document.querySelector('[data-museum-menu]');
    var form = document.querySelector('[data-museum-heroes-search-form]');
    var input = document.querySelector('[data-museum-heroes-search-input]');
    var resultsWrap = document.querySelector('[data-museum-heroes-search-results]');
    var resultsList = document.querySelector('[data-museum-heroes-search-list]');
    var resultsStatus = document.querySelector('[data-museum-heroes-search-status]');

    if (!form || !input) {
        return;
    }

    var heroesPageUrl = menu ? menu.getAttribute('data-museum-heroes-page-url') || form.getAttribute('action') : form.getAttribute('action');
    var heroUrlTemplate = menu ? menu.getAttribute('data-museum-hero-url') : '';
    var heroesIndex = menu ? parseHeroesIndex(menu) : null;
    var fetchTimer = null;
    var activeController = null;

    function setResultsVisible(visible) {
        if (!resultsWrap) {
            return;
        }

        resultsWrap.hidden = !visible;

        if (menu) {
            menu.classList.toggle('is-search-active', visible);
        }
    }

    function setStatus(message) {
        if (!resultsStatus) {
            return;
        }

        resultsStatus.textContent = message;
    }

    function renderResults(results) {
        if (!resultsList) {
            return;
        }

        resultsList.innerHTML = '';

        if (!results.length) {
            setResultsVisible(false);
            setStatus('Ничего не найдено');
            return;
        }

        setResultsVisible(true);
        setStatus(
            results.length === 1
                ? 'Найден 1 герой'
                : 'Найдено героев: ' + results.length
        );

        results.forEach(function (item) {
            var li = document.createElement('li');
            var link = document.createElement('a');

            link.className = 'museum-menu__search-link';
            link.href = heroUrlTemplate ? buildHeroUrl(heroUrlTemplate, item.slug) : heroesPageUrl;
            link.textContent = item.name.toUpperCase();
            link.addEventListener('click', function () {
                if (menu && menu.classList.contains('is-open')) {
                    document.body.classList.remove('museum-menu-open');
                    menu.classList.remove('is-open');
                    menu.hidden = true;
                    menu.setAttribute('aria-hidden', 'true');
                }
            });

            li.appendChild(link);
            resultsList.appendChild(li);
        });
    }

    function fetchResults(query) {
        if (heroesIndex) {
            renderResults(filterHeroesIndex(heroesIndex, query, 12));
            return;
        }

        if (activeController) {
            activeController.abort();
        }

        activeController = new AbortController();

        var url = new URL('/api/heroes/search', window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('limit', '12');

        fetch(url.toString(), { signal: activeController.signal })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('search failed');
                }

                return response.json();
            })
            .then(function (payload) {
                renderResults(payload.results || []);
            })
            .catch(function (error) {
                if (error.name === 'AbortError') {
                    return;
                }

                setResultsVisible(false);
                setStatus('Ошибка поиска');
            });
    }

    function handleInput() {
        var query = input.value.trim();

        window.clearTimeout(fetchTimer);

        if (query.length < 2) {
            if (activeController) {
                activeController.abort();
            }

            setResultsVisible(false);
            setStatus('');
            return;
        }

        fetchTimer = window.setTimeout(function () {
            fetchResults(query);
        }, 180);
    }

    function navigateToResults(query) {
        var results = heroesIndex
            ? filterHeroesIndex(heroesIndex, query, 50)
            : null;

        if (results && results.length === 1) {
            var only = results[0];
            var normalizedQuery = normalizeQuery(query);
            var normalizedName = normalizeQuery(only.name);

            if (
                normalizedName === normalizedQuery ||
                normalizedName.indexOf(normalizedQuery) === 0
            ) {
                window.location.href = buildHeroUrl(heroUrlTemplate, only.slug);
                return;
            }
        }

        var target = new URL(heroesPageUrl, window.location.origin);
        target.searchParams.set('q', query);
        window.location.href = target.toString();
    }

    input.addEventListener('input', handleInput);
    input.addEventListener('focus', handleInput);

    input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            setResultsVisible(false);
            setStatus('');
        }
    });

    form.addEventListener('submit', function (event) {
        var query = input.value.trim();

        if (!query) {
            return;
        }

        event.preventDefault();
        navigateToResults(query);
    });

    document.addEventListener('click', function (event) {
        if (!resultsWrap || resultsWrap.hidden) {
            return;
        }

        if (form.contains(event.target)) {
            return;
        }

        setResultsVisible(false);
    });

    var params = new URLSearchParams(window.location.search);
    var initialQuery = params.get('q');

    if (initialQuery) {
        input.value = initialQuery;
    }
}
